import { LogoutController } from "./logout";
import { decoratorWrapper } from "./sd-app.adal-401-suppressor";
import { addClosePromptEvent } from "./sd-app.close-prompt-on-unload";
import { registerUnloadListenerToFlushEvents, WindowWithAwa } from "./sd-app.flush-telemetry-on-unload";
import { registerTemplateCacheDecorator } from "./sd-app.template-cache-decorator";
import { SdAppConfiguration, SdAppRunOptions } from "./sd-app";
import { PrerequisiteLoadingService } from "../sdServices/loading/prerequisite-loading-service";
import { SdController } from "./sdController";
import { StartupNotification } from "./startupNotification";
import { LoggingService } from "../sdServices/loggingSvc";
import { FlightingServiceImplementation, FlightingService } from "../sdServices/flightingSvc";
import { JarvisService, JarvisServiceImplementation } from "../sdServices/jarvisSvc";
import { LocalizationService } from "../../ShellCommon/localization/localization";
import { AuthorizationService } from "../sdServices/authorization/authorization";
import { AgentProfileEntityServiceImplementation } from "../sdServices/entity-service-implementation/agent-profile-entity-service";
import { ReleaseNotesService } from "../sdServices/release-notes-config/release-notes-service";
import { FeatureConfigService } from "../sdServices/feature-config/feature-config";
import app from "../sdAppModule";
import { ResourceTimingLoggerService } from "../../ShellCommon/logger/resource-timing-logger";

declare let agGrid: any;
agGrid.initialiseAgGridWithAngular1(angular);

// @ngInject
app
  .controller("LogoutController", LogoutController)
  .controller("sdController", SdController)
  .config(function ($animateProvider: any) {
    // word must follow start of string or whitespace, but cannot follow hyphen. Cannot end in hyphen, must be followed by end of string or whitespace
    $animateProvider.classNameFilter(/(?=[^\-])(^| +)animated(?!-)($|\s+)/);
  })
  .config(() => registerUnloadListenerToFlushEvents(window as any as WindowWithAwa))
  .config(($provide: ng.auto.IProvideService) => registerTemplateCacheDecorator($provide))
  .config(SdAppConfiguration)
  .run(($state: ng.ui.IStateService) => addClosePromptEvent($state))
  .run(
    (
      flightingService: FlightingServiceImplementation,
      jarvisService: JarvisServiceImplementation,
      sdLocalizationService: LocalizationService,
      $rootScope: ng.IRootScopeService,
      loggingService: LoggingService,
      $window: ng.IWindowService,
      $state: angular.ui.IStateService,
      agentProfileEntityService: AgentProfileEntityServiceImplementation,
      authorizationService: AuthorizationService,
      $q: ng.IQService
    ) => {
      new StartupNotification(
        flightingService,
        jarvisService,
        sdLocalizationService,
        $rootScope,
        loggingService,
        $window,
        $state,
        agentProfileEntityService,
        authorizationService,
        $q
      );
    }
  )
  .run(SdAppRunOptions)
  .run(($animate: any, featureConfigService: FeatureConfigService) => {
    $animate.enabled(false);
    const serviceDeskAppId = "ServiceDesk";
    // Register feature flights
    featureConfigService.registerFeature(serviceDeskAppId, "EAE_PM_OR_DEV", "EAE_PM_OR_DEV");
    featureConfigService.registerFeature(serviceDeskAppId, "ReleaseNotesAndSummary", "SD_RELEASE_NOTES");
  });
